import React, { Component } from "react";
import Modal from "../Modal/Modal";
import Input from "../Input/Input";
import {CopyToClipboard} from "react-copy-to-clipboard";

class CopyLinkModal extends Component {
  constructor(props) {
    super(props);
    this.state =  {
      copied: false
    }
  }

  render() {
    return (
      <Modal handleDismiss={this.props.handleDismiss}>
        <div className="voting-error-modal">
          <h3>Share this link</h3>
          <p>Copy the link below to share</p>
          <Input value={this.props.url} focusOnMount readOnly style={{width: '100%', marginBottom: 0}}/>
          <div style={{ marginBottom: 10, cursor: 'pointer' }}>
            <CopyToClipboard text={this.props.url}
              onCopy={() => this.setState({copied: true})}>
              <span>Copy to clipboard</span>
            </CopyToClipboard>
          </div>
          {this.state.copied && <p className="fineprint -copied">Copied to clipboard!</p>}
        </div>
      </Modal>
    );
  }
}

export default CopyLinkModal;



// WEBPACK FOOTER //
// ./src/components/CopyLinkModal/CopyLinkModal.js